<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="编辑电梯"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="760px"
    :modal="false"
  >
    <div class="dialog__container">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="125px"
      >
        <h4>基本信息</h4>
        <el-form-item label="设备代码：" prop="liftNumber">
          <el-input
            size="mini"
            v-model.trim="form.liftNumber"
            placeholder="请输入设备代码"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="年检日期：" class="mr0" prop="annualInspectionDate">
          <el-input
            size="mini"
            v-model.trim="form.annualInspectionDate"
            placeholder="请输入年检日期"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="法人(负责人)：" prop="legalPersonMobile">
          <el-input
            size="mini"
            v-model.trim="form.legalPerson"
            placeholder="请输入法人(负责人)"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="法人(负责人)手机：" prop="legalPersonMobilePhone">
          <el-input
            size="mini"
            v-model.trim="form.legalPersonMobilePhone"
            placeholder="请输入法人(负责人)手机"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="法人(负责人)电话：" class="mr0" prop="legalPersonPhone">
          <el-input
            size="mini"
            v-model.trim="form.legalPersonPhone"
            placeholder="请输入法人(负责人)电话"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="安管人员：" prop="securityManagement">
          <el-input
            size="mini"
            v-model.trim="form.securityManagement"
            placeholder="请输入安管人员"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="安管人员手机：" class="mr0" prop="securityManagementMobilePhone">
          <el-input
            size="mini"
            v-model.trim="form.securityManagementMobilePhone"
            placeholder="请输入安管人员手机"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="安管人员电话：" prop="securityManagementPhone">
          <el-input
            size="mini"
            v-model.trim="form.securityManagementPhone"
            placeholder="请输入安管人员电话"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="下检日期：" class="mr0" prop="nextAnnualInspectionDate">
          <el-input
            size="mini"
            v-model.trim="form.nextAnnualInspectionDate"
            placeholder="请输入下检日期"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="单位内编号："  prop="innerCode">
          <el-input
            size="mini"
            v-model.trim="form.innerCode"
            placeholder="请输入单位内编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="制造单位：" class="mr0" prop="manufactureCompany">
          <el-input
            size="mini"
            v-model.trim="form.manufactureCompany"
            placeholder="请输入制造单位"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="维保单位：" prop="maintainCompany">
          <el-input
            size="mini"
            v-model.trim="form.maintainCompany"
            placeholder="请输入维保单位"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="设备参数：" class="mr0" prop="equipmentParameters">
          <el-input
            size="mini"
            v-model.trim="form.equipmentParameters"
            placeholder="请输入设备参数"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item label="型号：" prop="liftModel">
          <el-input
            size="mini"
            v-model.trim="form.liftModel"
            placeholder="请输入型号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="品牌：" prop="liftBrand">
          <el-input
            size="mini"
            v-model.trim="form.liftBrand"
            placeholder="请输入品牌"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="类型：" class="mr0" prop="liftType">
          <el-input
            size="mini"
            v-model.trim="form.liftType"
            placeholder="请输入类型"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="层站门/跨度："
          class="mr0 label-with-six-word input-with-col2"
          label-width="98px"
        >
          <el-input
            size="mini"
            v-model.trim="form.stationNumber"
            placeholder="请输入层站门/跨度"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="载重：">
          <el-input
            size="mini"
            v-model.trim="form.nominalLoad"
            placeholder="请输入载重"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="速度：" class="mr0">
          <el-input
            size="mini"
            v-model.trim="form.nominalSpeed"
            placeholder="请输入速度"
            clearable
          ></el-input>
        </el-form-item>
        <h4>价格信息</h4>
        <el-form-item label="设备单价：">
          <el-input
            size="mini"
            v-model.trim="form.equipmentPrice"
            v-number-only:20="2"
            placeholder="请输入设备单价"
            clearable
          >
            <span slot="suffix">元</span>
          </el-input>
        </el-form-item>
        <el-form-item label="运费单价：" class="mr0">
          <el-input
            size="mini"
            v-model.trim="form.freightPrice"
            v-number-only:20="2"
            placeholder="请输入运费单价"
            clearable
          >
            <span slot="suffix">元</span>
          </el-input>
        </el-form-item>
        <el-form-item label="安装单价：" class="input-with-col4 mr0">
          <el-input
            size="mini"
            v-model.trim="form.installPrice"
            v-number-only:20="2"
            placeholder="请输入安装单价"
            clearable
          >
            <span slot="suffix">元</span>
          </el-input>
        </el-form-item>
        <el-form-item
          label="其他单价1："
          class="label-with-five-word"
          label-width="84px"
        >
          <el-input
            size="mini"
            v-model.trim="form.otherPrice01"
            v-number-only:20="2"
            placeholder="请输入其他单价1"
            clearable
          >
            <span slot="suffix">元</span>
          </el-input>
        </el-form-item>
        <el-form-item
          label="其他单价2："
          label-width="84px"
          class="mr0 label-with-five-word"
        >
          <el-input
            size="mini"
            v-model.trim="form.otherPrice02"
            v-number-only:20="2"
            placeholder="请输入其他单价2"
            clearable
          >
            <span slot="suffix">元</span>
          </el-input>
        </el-form-item>
        <el-form-item
          label="其他单价3："
          label-width="84px"
          class="mr0 input-with-col4"
        >
          <el-input
            size="mini"
            v-model.trim="form.otherPrice03"
            v-number-only:20="2"
            placeholder="请输入其他单价3"
            clearable
          >
            <span slot="suffix">元</span>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="plr28"
        size="mini"
        type="info"
        plain
        @click="handleCancel"
        >取消</el-button
      >
      <el-button
        class="plr28"
        type="primary"
        size="mini"
        :loading="loadBtn"
        @click="handleConfirm"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>


<script>
import { saveLift } from "@/api/salesManagement/detail";
export default {
  data() {
    return {
      form: {
        liftNumber: "",
        liftModel: "",
        liftBrand: "",
        liftType: "",
        annualInspectionDate:"",
        stationNumber: "",
        nominalLoad: "",
        nominalSpeed: "",
        equipmentPrice: "",
        freightPrice: "",
        installPrice: "",
        otherPrice01: "",
        otherPrice02: "",
        otherPrice03: "",
      },
      rules: {
        liftNumber: [
          {
            required: true,
            message: "请输入电梯设备代码",
            trigger: "change",
          },
        ],
      },
      loadBtn: false,
    };
  },
  props: {
    editData: {
      type: Object,
      required: true,
    },
    projectId: {
      required: true,
    }
  },
  created() {
    this.form = {...this.editData}
  },
  methods: {
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      if (this.loadBtn) return;
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loadBtn = true;
          const queryData = { ...this.form, projectId: this.projectId };
          const res = await saveLift(queryData);
          if (res.code === 200) {
            this.$message.success("编辑成功");
            this.$emit("confirm");
          }
          this.loadBtn = false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.search-div {
  display: flex;
  align-items: center;
  .search-button {
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/salesManagement/xmgl/components/DetailProoject/EditLift.vue